<div class="container">
  <span class="eyebrow">{{ 'contact.eyebrow' | traduire }}</span>
  <h3 class="titre-contact">{{ 'contact.titre' | traduire }}</h3>

  <div class="contact-grid">
    <div class="contact-carte">
      <div class="icone">📍</div>
      <h4>{{ 'contact.adresse' | traduire }}</h4>
      <p>{{ parametres?.adresse || 'Théâtre de Sidi Dhaher, Sousse, Tunisie' }}</p>
    </div>
    <div class="contact-carte">
      <div class="icone">✉</div>
      <h4>{{ 'contact.email' | traduire }}</h4>
      <p><a [href]="'mailto:' + (parametres?.email || 'contact@festival-sousse.tn')">{{ parametres?.email || 'contact@festival-sousse.tn' }}</a></p>
    </div>
    <div class="contact-carte">
      <div class="icone">☎</div>
      <h4>{{ 'contact.telephone' | traduire }}</h4>
      <p><a [href]="'tel:' + (parametres?.telephone || '')">{{ parametres?.telephone || '+216 73 000 000' }}</a></p>
    </div>
    <div class="contact-carte">
      <div class="icone">🌐</div>
      <h4>{{ 'contact.suivez' | traduire }}</h4>
      <p class="reseaux">
        <a *ngIf="parametres?.facebook" [href]="parametres?.facebook" target="_blank">Facebook</a>
        <a *ngIf="parametres?.instagram" [href]="parametres?.instagram" target="_blank">Instagram</a>
        <span *ngIf="!parametres?.facebook && !parametres?.instagram" style="color:var(--stone);">—</span>
      </p>
    </div>
  </div>

  <div class="contact-carte-map">
    <iframe
      [src]="urlCarteContact"
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade">
    </iframe>
  </div>
</div>
